import * as Sentry from '@sentry/angular';
import { replayIntegration } from '@sentry/browser';
import { ErrorHandler } from '@angular/core';
import { processSentryEvent } from './sentry-http-error.utils';

export function getSentryErrorHandlerProvider(): any {
  return {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({
      logErrors: false,
    }),
  };
}

export function initSentry(env: any, projectName?: string): void {
  if (!env || !env.sentryDsn) {
    if (!env.production) {
      console.warn('[Sentry] DSN not configured or environment not found');
    }
    return;
  }

  try {
    const environmentName = env.isLocalhost
      ? 'local'
      : env.isPROD
        ? 'production'
        : env.isDEMO
          ? 'demo'
          : env.isRC
            ? 'rc'
            : env.isDEV
              ? 'dev'
              : env.isQA
                ? 'qa'
                : 'local';

    const releaseBase = 'solvace-revamp-angular';
    const releaseProject = projectName ? `-${projectName}` : '';
    const releaseDate = new Date().toISOString().split('T')[0];
    const release = `${releaseBase}${releaseProject}@${environmentName}-${releaseDate}`;

    Sentry.init({
      dsn: env.sentryDsn,
      integrations: [
        replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
        Sentry.browserTracingIntegration(),
      ],
      tracesSampleRate: env.production ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.2,
      replaysOnErrorSampleRate: 1.0,
      environment: environmentName,
      release: release,
      debug: false,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'Non-Error promise rejection captured',
        /NG0955/,
        /duplicated keys/i,
        /Http failure response.*: 0 Unknown Error/i,
        /Http failure response.*\/user\/infos\/cached: 400/i,
        /Http failure response.*\/CommentByReferenceIds\/.*counter: 0/i,
        /Http failure response.*\/CountersId\/RegistryUniqueIds: 400/i,
        /Loading icon set URL:.*failed:/i,
        /Http failure response.*\/assets\/icons\/.*\.svg/i,
      ],
      beforeSend: (event, hint) => processSentryEvent(event, hint),
    });
  } catch (error) {
    if (!env.production) {
      console.error('[Sentry] Error initializing Sentry:', error);
    }
  }
}
